'use strict'
const {
    migrateStylableComponentsByCompType
} = require('../helpers/stylableMigration/migrateStylableComponentsByCompType')

const BREADCRUMBS_COMPTYPE = 'wixui.Breadcrumbs'
const BREADCRUMBS_NON_STYLABLE_SKIN = 'wixui.skins.Breadcrumbs'

const CSS_PROP_TO_VAR_NAME = {
    'background-color': 'text-highlight',
    'text-decoration-line': 'text-decoration',
    'text-direction': 'direction'
}

const migratePage = (structure, data, uniqueIdGenerator, clientSpecMap, magicObject) => {
    migrateStylableComponentsByCompType({
        magicObject,
        structure,
        data,
        uniqueIdGenerator,
        clientSpecMap,
        newSkin: BREADCRUMBS_NON_STYLABLE_SKIN,
        compType: BREADCRUMBS_COMPTYPE,
        selectorsMappings: {
            '.root': {
                name: 'root',
                removePrefix: true,
                properties: CSS_PROP_TO_VAR_NAME
            },
            '.root::separator': {
                name: 'separator',
                properties: CSS_PROP_TO_VAR_NAME
            },
            '.root::breadcrumb-content': {
                name: 'breadcrumb-content',
                properties: CSS_PROP_TO_VAR_NAME
            },
            '.root::breadcrumb-content:iscurrent': {
                root: 'breadcrumb-content',
                name: 'breadcrumb-content-current',
                properties: CSS_PROP_TO_VAR_NAME
            },
            '.root::breadcrumb-content:hover': {
                root: 'breadcrumb-content',
                name: 'breadcrumb-content-hover',
                properties: CSS_PROP_TO_VAR_NAME
            }
        }
    })
}

// DRAFT MIGRATION - this migration is not complete missing bug fixes & tests
module.exports = {
    name: 'BreadcrumbsStylesFixer',
    version: 0,
    experimentalVersions: [
        {experiment: 'dm_migrateBreadcrumbsToNonStylable', version: 1},
        {experiment: 'dm_migrateBlocksWidgetsToNonStylable', version: 2}
    ],
    exec(pageJson, pageIdsArray, magicObject) {
        const {clientSpecMap} = magicObject
        const {uniqueIdGenerator} = magicObject.dataFixerUtils

        if (!magicObject.isExperimentOpen('dm_migrateBreadcrumbsToNonStylable')) {
            return
        }

        const {data, structure} = pageJson
        migratePage(structure, data, uniqueIdGenerator, clientSpecMap, magicObject)
    },
    fixerRequiresReruns: true
}
